export default {
      id: "txt_break-usage",
      viewBox: "0 0 20 17",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_break",
      toString: function () {
        return this.url;
      }
    }